<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="logout()">
      <v-icon color="primary">meeting_room</v-icon>
    </v-btn>
    <span>Logout</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$emit("logout");
    }
  }
};
</script>

<style>
</style>
